import React from 'react';
import PropTypes from 'prop-types';

import kumoJanai from './kumo-janai.svg';
import './Dashboard.scss';

const ErrorTile = (props) => {
  if (props.hasError && props.error) {
    return (
      <div id="move-address-tile" className="account-action-tile">
        <img
          src={kumoJanai}
          alt="Error"
        />
        <div className="account-action-tile-title contact-us-error">
          An Error Has Occurred
        </div>
        <div className="account-action-tile-text">
          <div className="contact-us-error">
            {props.error.status.code} {props.error.status.text}
          </div>
          {props.error.entity &&
          <div className="contact-us-error">
            {props.error.entity.message}
          </div>
          }
        </div>
      </div>
    );
  }
  return null;
};

ErrorTile.propTypes = {
  hasError: PropTypes.bool,
  error: PropTypes.object
};

export default ErrorTile;



/** WEBPACK FOOTER **
 ** ./src/components/myaccount/Dashboard/ErrorTile.js
 **/